export interface UserResponse {
  country_code: string
  mobile: string
  email: string
  first_name: string
  last_name: string
  status: string
  is_superuser: boolean
  is_verified: boolean
  id: string
  description: string | null
  profile_image: string
  kyc_image: string
  created_at: string
  updated_at: string
  last_login: string
}

export default class User {
  countryCode: string
  mobile: string
  email: string
  firstName: string
  lastName: string
  status: string
  isSuperuser: boolean
  isVerified: boolean
  id: string
  description: string | null
  profileImage: string
  kycImage: string
  createdAt: string
  updatedAt: string
  lastLogin: string

  constructor(data: UserResponse) {
    this.countryCode = data.country_code
    this.mobile = data.mobile
    this.email = data.email
    this.firstName = data.first_name
    this.lastName = data.last_name
    this.status = data.status
    this.isSuperuser = data.is_superuser
    this.isVerified = data.is_verified
    this.id = data.id
    this.description = data.description
    this.profileImage = data.profile_image
    this.kycImage = data.kyc_image
    this.createdAt = data.created_at
    this.updatedAt = data.updated_at
    this.lastLogin = data.last_login
  }
}
